<template>
  <div class="row">
    <div class="col-md-6">
      <h3 class="title"></h3>
    </div>
    <div class="col-md-6">
      <p-button native-type="button" type="info" class="btn btn-info btn-md float-right" @click.native="add_project()">Add project</p-button>
    </div>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="title">Projects</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination_p.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination_p.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery_p"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class=""
                    ref="projects"
                    :data="projects_data"
                    border
                    highlight-current-row
                    @current-change="handleCurrentChange_p"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    >
            <el-table-column v-for="column in tableColumns_p1"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             sortable
                             >
            </el-table-column>

            <el-table-column
              label="Status"
              min-width="100"
              align="center"
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 1" size="small" type="" effect="dark"> NEW </el-tag>
                  <el-tag v-else-if="scope.row.status === 3" size="small" type="warning" effect="dark"> IN PROCESS </el-tag>
                  <el-tag v-else-if="scope.row.status === 5" size="small" type="info" effect="dark"> PROCESSED </el-tag>
                  <el-tag v-else-if="scope.row.status === 7" size="small" type="success" effect="dark"> FINISHED </el-tag>
                  <el-tag v-else size="small" type="default" effect="plain">  </el-tag>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_p2"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             sortable
                             >
            </el-table-column>

            <el-table-column
              :min-width="100"
              fixed="right"
              class-name="td-actions"
              label="Actions">
              <template slot-scope="props">
                <p-button type="info" size="sm" icon @click="handle_project_detail(props.$index, props.row, $event)">
                  <i class="fas fa-edit"></i>
                </p-button>
                <!-- <p-button v-if="props.row.status > 6" type="default" size="sm" icon @click.prevent="handleShowQC(props.$index, props.row, $event)">
                  <i class="fas fa-chart-pie"></i>
                </p-button> -->
                <p-button v-if="props.row.status < 3" type="danger" size="sm" icon @click="handle_project_delete(props.$index, props.row, $event)">
                  <i class="fa fa-times"></i>
                </p-button>
                <p-button v-if="props.row.status > 4" type="success" size="sm" icon @click="handle_show_nextstrain(props.$index, props.row, $event)">
                  <i class="fa fa-link"></i>
                </p-button>
                <p-button v-if="props.row.status > 4" type="default" size="sm" icon @click="handleReport(props.$index, props.row, $event)">
                  <i class="far fa-file-pdf"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{total_p === 0 ? 0 : from_p + 1}} to {{to_p}} of {{total_p}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination_p.currentPage"
                        :per-page="pagination_p.perPage"
                        :total="pagination_p.total"
                        type="light"
                        >
          </p-pagination>
        </div>
      </div>
    </div>


    <modal :show.sync="modal_new_project" headerClasses="justify-content-center" :show-close="true"  @close="handle_close_modal">
      <h4 slot="header" class="title title-up">Add New project</h4>
      <form @submit.prevent="submit_np">
        <div class="row">
          <div class="col-md-12">
              <label>Project Name</label>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="" v-model="new_project_name">
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 mr-auto ml-auto">
            <button type="submit" class="btn btn-success">Submit</button>
          </div>
        </div>
      </form>
    </modal>


    <modal :show.sync="modal_nextstrain" headerClasses="justify-content-center" :show-close="true"  @close="handle_close_modal">
      <h4 slot="header" class="title title-up">Link to NextStrain</h4>
        <div class="row">
          <div class="col-md-12">
              <label>Your URL:</label>
              <div class="form-group">
                <el-input v-model="nextstrain_link" class="">
                  <el-button slot="append" icon="fas fa-copy" @click.native="handle_button_nextstrain($event)"></el-button>
                </el-input>
              </div>
          </div>
        </div>
    </modal>


    <modal :show.sync="modal_project_detail" headerClasses="justify-content-center" :show-close="true" @close="handle_close_modal_detail">
      <h4 slot="header" class="title title-up">Project ID: {{ project_detail.id_project }}</h4>

      <div class="row">
        <el-tabs class="col-md-12" type="card" v-model="which_tab" @tab-click="load_data_files">
          <el-tab-pane label="Project Name" name="tab_1">
            <div class="col-md-12">
              <h6 slot="" class="title text-center">Items with asterisk (*) are mandatory</h6>
              <form>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Project Name</div>
                        <el-input type="text" placeholder="" size="small" v-model="project_detail.name"></el-input>

                        <div class="sub-title">Workflow <b class="my_asterisk"> * </b></div>
                        <el-select class="select-neutral"
                                  placeholder="Select Workflow"
                                  size="small"
                                  v-model="project_detail.id_workflow">
                          <el-option v-for="option in workflows"
                                    class="select-info"
                                    :value="option.id_workflow"
                                    :label="option.public_name"
                                    :key="option.id_workflow">
                          </el-option>
                        </el-select>

                        <div class="sub-title">Seq. Technology <b class="my_asterisk"> * </b></div>
                        <el-select class="select-neutral"
                                  placeholder=""
                                  size="small"
                                  v-model="project_detail.seq_technology">
                          <el-option v-for="option in seq_technology"
                                    class="select-info"
                                    :value="option.id"
                                    :label="option.label"
                                    :key="option.id">
                          </el-option>
                        </el-select>

                        <div class="sub-title">Description</div>
                        <textarea type="textarea" class="form-control" rows="3" placeholder="" size="small" v-model="project_detail.description"> </textarea>

                        <div class="sub-title">Authors <b class="my_asterisk"> * </b></div>
                        <textarea type="textarea" class="form-control" rows="3" placeholder="" size="small" v-model="project_detail.authors"> </textarea>

                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Type</div>
                        <el-input type="text"
                                  size="small"
                                  :disabled="true"
                                  placeholder=""
                                  v-model="project_detail.type">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Passage <b class="my_asterisk"> * </b></div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="project_detail.passage">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Location <b class="my_asterisk"> * </b></div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="project_detail.location">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Host <b class="my_asterisk"> * </b></div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="project_detail.host">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Assembly Method</div>
                        <el-input type="text"
                                  size="small"
                                  :disabled="true"
                                  placeholder=""
                                  v-model="project_detail.assembly_method">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Provider Sample ID</div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="project_detail.provider_sample_id">
                        </el-input>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Original Laboratory <b class="my_asterisk"> * </b></div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="project_detail.orig_lab"> </textarea>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Original Laboratory Address <b class="my_asterisk"> * </b></div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="project_detail.orig_lab_addr"> </textarea>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Submitter Laboratory <b class="my_asterisk"> * </b></div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="project_detail.subm_lab"> </textarea>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">Submitter Laboratory Address <b class="my_asterisk"> * </b></div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="project_detail.subm_lab_addr"> </textarea>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 mr-auto ml-auto">
                    <p-button type="info" block @click.native="submit_project_detail()">Submit</p-button>
                  </div>
                </div>
              </form>
            </div>
          </el-tab-pane>

          <!-- <el-tab-pane label="QC Parameters" name="tab_1A">
            <div class="col-md-12">
              <h6 slot="" class="title text-center">Items with asterisk (*) are mandatory</h6>
              <form>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">READ DEPTH min.</div>
                        <el-input-number placeholder="" controls-position="right" v-model="project_params.min_read_depth" size="small" :step="1" :min="0"></el-input-number>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Missing Data (%)</div>
                        <el-input-number placeholder="" controls-position="right" v-model="project_params.miss_data" size="small" :step="1" :min="0"></el-input-number>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">FREQ VCF min. (%)</div>
                        <el-input-number placeholder="" controls-position="right" v-model="project_params.min_var_freq" size="small" :step="1" :min="0"></el-input-number>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Private Mutations (%)</div>
                        <el-input-number placeholder="" controls-position="right" v-model="project_params.priv_mut" size="small" :step="1" :min="0"></el-input-number>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Min Base Quality</div>
                        <el-input-number placeholder="" controls-position="right" v-model="project_params.min_base_qual" size="small" :step="10" :min="0"></el-input-number>
                      </div>
                    </div>
                  </div>

                </div>

                <el-divider></el-divider>

                <div class="row">
                  <div class="col-md-4 mr-auto ml-auto">
                    <p-button type="info" block @click.native="submit_project_params()">Submit</p-button>
                  </div>
                </div>
              </form>
            </div>
          </el-tab-pane> -->

          <el-tab-pane label="Upload examinations from XLSX File" name="tab_2">
            <div class="col-md-12">
              <ul>
                <li v-for="afile in xlsx_file">{{afile.name}} - status: {{ "Uploaded." ? afile.success : ""}}</li>
              </ul>
              <file-upload
                class="btn btn-primary"
                ref="uploadxlsx"
                input-id="filexlsx"
                v-model="xlsx_file"
                :multiple="false"
                :size="1024 * 1024 * 100"
                :extensions="['xlsx']"
                :post-action="g_upload_xlsx"
                @input-file="inputFilexlsx"
                :data="{
                    token: this.token,
                    id_project: this.project_detail.id_project,
                    collection: 'f_s'
                }"
              >
              Select EXCEL file
              </file-upload>
              <span class="mezera"> </span>
              <button class="btn btn-primary" v-show="!$refs.uploadxlsx || !$refs.uploadxlsx.active" @click.prevent="$refs.uploadxlsx.active = true" type="button">Start upload</button>
              <button class="btn btn-warning" v-show="$refs.uploadxlsx && $refs.uploadxlsx.active" @click.prevent="$refs.uploadxlsx.active = false" type="button">Stop upload</button>
            </div>

          <mongo-files collection="f_s" :modify="false" :myfiles="u_f_s" :extensions="['xlsx', ]"> </mongo-files>

          </el-tab-pane>

          <el-tab-pane label="FASTQ Files" name="tab_3">
            <mongo-files collection="f_q" :modify="true" :myfiles="u_f_q" :extensions="['gz', 'fastq', ]"> </mongo-files>
          </el-tab-pane>

          <el-tab-pane label="FASTA Files" name="tab_4">
            <mongo-files collection="f_a" :modify="false" :myfiles="u_f_a" :extensions="['fna', 'fasta', ]"> </mongo-files>
          </el-tab-pane>

          <el-tab-pane label="GISAID Data" name="tab_5">
            <mongo-files collection="f_m" :modify="false" :myfiles="u_f_m" :extensions="['csv', 'html', ]"> </mongo-files>
          </el-tab-pane>

          <el-tab-pane label="Other Files" name="tab_6">
            <mongo-files collection="f_o" :modify="true" :myfiles="u_f_o" :extensions="['pdf', 'csv', 'tsv', 'xlsx', 'docx', 'doc', 'html', 'htm', 'odt', 'ods', 'mkv', 'jpg', 'png']"> </mongo-files>
          </el-tab-pane>

          <el-tab-pane label="Result Files" name="tab_7">
            <mongo-files collection="f_e" :modify="false" :myfiles="u_f_e" :extensions="['csv', 'json']"> </mongo-files>
          </el-tab-pane>

          <el-tab-pane label="MULTIFASTA" name="tab_8">
            <mongo-files collection="f_u" :modify="false" :myfiles="u_f_u" :extensions="['csv', 'fasta', ]"> </mongo-files>
          </el-tab-pane>

        </el-tabs>
      </div>
    </modal>


  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import {Table, TableColumn, Select, Option, Tabs, TabPane, Tooltip, Progress, Tag, Input } from 'element-ui';
  import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import Modal from 'src/components/UIComponents/Modal'
  import Exams from 'src/components/Views/Exams.vue';
  import MongoFiles from 'src/components/Views/MongoFiles.vue';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  import FileSaver from 'file-saver';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Tabs);
  Vue.use(Select);
  Vue.use(Option);

  export default {
    name: 'projects',
    props: {
    },
    components: {
      PPagination,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Tooltip.name]: Tooltip,
      [Tag.name]: Tag,
      [Exams.name]: Exams,
      [MongoFiles.name]: MongoFiles,
      Modal,
      Input,
    },
    computed: {
      ...mapState({
        projects: state => state.projects,
        id_project: state => state.id_project,
        id_project_detail: state => state.id_project_detail,
        examinations: state => state.examinations,
        id_examination: state => state.id_examination,
        vars: state => state.vars,
        id_var: state => state.id_var,
        workflows: state => state.workflows,
        collection: state => state.collection,
        subject: state => state.subject,
        current_url: state => state.current_url,

        f_a: state => state.f_a,
        f_u: state => state.f_u,
        f_q: state => state.f_q,
        f_m: state => state.f_m,
        f_o: state => state.f_o,
        f_e: state => state.f_e,
        f_s: state => state.f_s,

        u_f_a: state => state.u_f_a,
        u_f_u: state => state.u_f_u,
        u_f_q: state => state.u_f_q,
        u_f_m: state => state.u_f_m,
        u_f_o: state => state.u_f_o,
        u_f_e: state => state.u_f_e,
        u_f_s: state => state.u_f_s,

        qc_redirect: state => state.qc_redirect,
        project_detail: state => state.project_detail,

        user: state => state.user,
        token: state => state.token,
        current_url: state => state.current_url,

      }),

      ...mapGetters({
        g_upload_xlsx: 'g_upload_xlsx',
      }),


      pagedData_p () {
        return this.projects.slice(this.from_p, this.to_p)
      },

      projects_data () {
        if (!this.searchQuery_p) {
          this.pagination_p.total = this.projects.length
          return this.pagedData_p
        }
        let result = this.projects
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_p) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_p)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_p.total = result.length
        return result.slice(this.from_p, this.to_p)
      },

      to_p () {
        let highBound = this.from_p + this.pagination_p.perPage
        if (this.total_p < highBound) {
          highBound = this.total_p
        }
        return highBound
      },

      from_p () {
        return this.pagination_p.perPage * (this.pagination_p.currentPage - 1)
      },

      total_p () {
        this.pagination_p.total = this.projects.length
        return this.projects.length
      },


      modal_new_project: {
        get () {
          return this.$store.state.modal_new_project;
        },
        set (value) {
          this.$store.commit('m_modal_new_project', value);
        }
      },

      modal_project_detail: {
        get () {
          return this.$store.state.modal_project_detail;
        },
        set (value) {
          this.$store.commit('m_modal_project_detail', value);
        }
      },

      modal_nextstrain: {
        get () {
          return this.$store.state.modal_nextstrain;
        },
        set (value) {
          this.$store.commit('m_modal_nextstrain', value);
        }
      },


    },


    data () {
      return {
        new_project_name: "",
        seq_technology: [
        { id: 1, label: "Illumina MiSeq"},
        { id: 2, label: "Illumina HiSeq"},
        { id: 3, label: "Illumina NovaSeq"},
        { id: 4, label: "Illumina iSeq"},
        { id: 5, label: "Illumina NextSeq"},
        { id: 6, label: "Illumina MiniSeq"},
        { id: 7, label: "Sanger"},
        { id: 8, label: "Nanopore MinION"},
        { id: 9, label: "Ion Torrent"},
        { id: 10, label: "MGI"},
        ],

        project_params: {
          min_read_depth: 20,
          min_var_freq: 90,
          min_base_qual: 30,
          miss_data: 5,
          priv_mut: 1,
        },

        formdata_ep: {
          id_project: 0,
          name: "",
          description: "",
        },

        formdata_nss: {
          description: "",
        },

        formdata_patients: {
          metadata: "",

        },

        nextstrain_link: "",
        which_tab: "tab_1",

        files: [],
        xlsx_file: [],
        other_files: [],

        pagination_p: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery_p: '',
        propsToSearch_p: ['name', ],
        tableColumns_p1: [
          {
            prop: 'id_project',
            label: 'ID',
            minWidth: 30
          },
          {
            prop: 'name',
            label: 'Project Name',
            minWidth: 120
          },
          {
            prop: 'workflow',
            label: 'Workflow',
            minWidth: 100
          },
        ],

       tableColumns_p2: [
          {
            prop: 'description',
            label: 'Description',
            minWidth: 200
          },
        ],

        pagination_fd: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, ],
          total: 0
        },
        searchQuery_fd: '',
        propsToSearch_fd: ['name', ],
        tableColumns_fd: [
          {
            prop: 'filename',
            label: 'File name',
            minWidth: 120,
            align: "left"
          },
          {
            prop: 'md5',
            label: 'MD5',
            minWidth: 120,
            align: "left"
          },

        ],

        pagination_fo: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, ],
          total: 0
        },
        searchQuery_fo: '',
        propsToSearch_fo: ['name', ],
        tableColumns_fo: [
          {
            prop: 'filename',
            label: 'File name',
            minWidth: 120,
            align: "left"
          },
          {
            prop: 'md5',
            label: 'MD5',
            minWidth: 120,
            align: "left"
          },


        ],

        project_name: "",

      }
    },

    methods: {

      ...mapMutations({
        m_id_project: 'm_id_project',
        m_id_project_detail: 'm_id_project_detail',
        m_project_detail: 'm_project_detail',
        m_id_examination: 'm_id_examination',
        m_id_var: 'm_id_var',
        m_np_id_workflow: 'm_np_id_workflow',
        m_modal_new_project: 'm_modal_new_project',
        m_modal_project_detail: 'm_modal_project_detail',
        m_modal_project_stat: 'm_modal_project_stat',
        m_modal_nextstrain: 'm_modal_nextstrain',
        m_collection: 'm_collection',
        m_substs: 'm_substs',

        m_f_q: 'm_f_q',
        m_f_a: 'm_f_a',
        m_f_u: 'm_f_u',
        m_f_m: 'm_f_m',
        m_f_o: 'm_f_o',
        m_f_e: 'm_f_e',
        m_f_s: 'm_f_s',

        m_qc_redirect: 'm_qc_redirect',
      }),


      ...mapActions({
        a_projects: 'a_projects',
        a_projects_refresh: 'a_projects_refresh',
        a_examinations: 'a_examinations',
        a_vars: 'a_vars',
        a_workflows: 'a_workflows',
        a_new_project: 'a_new_project',
        a_project_detail: 'a_project_detail',
        a_project_detail_get: 'a_project_detail_get',
        a_project_delete: 'a_project_delete',
        a_show_qc: 'a_show_qc',
        a_mongo_files: 'a_mongo_files',
        a_project_files_data: 'a_project_files_data',
        a_project_files_others: 'a_project_files_others',
        a_notify: 'a_notify',
        a_substs: 'a_substs',


        }),


      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      },

      handle_project_detail (index, row, event) {
        event.stopImmediatePropagation();
        this.a_project_detail_get(row.id_project);
        this.m_id_project_detail(row.id_project);
        this.m_project_detail(row.id_project);
        this.m_f_q([]);
        this.m_f_a([]);
        this.m_f_u([]);
        this.m_f_m([]);
        this.m_f_o([]);
        this.m_f_e([]);
        this.m_f_s([]);
        this.m_modal_project_detail(true);
        this.which_tab = "tab_1";
      },

      handle_project_stat (index, row, event) {
        event.stopImmediatePropagation();
        // this.formdata_ep.id_project = row.id_project;
        // this.formdata_ep.name = row.name;
        // this.formdata_ep.description = row.description;
        this.m_id_project_detail(row.id_project);
        // this.files = [];
        // this.other_files = [];
        // this.csv_file = [];
        this.m_modal_project_stat(true);

      },


      handle_project_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_project_delete( {'id_project': row.id_project} );
      },


      handle_show_nextstrain (index, row, event) {
        // event.stopImmediatePropagation();
        this.nextstrain_link = this.current_url.protocol + "//" + this.current_url.hostname + "/ra/merge_fasta?my_project=" + row.id_project;
        this.m_id_project_detail(row.id_project);
        this.m_modal_nextstrain( true );
      },


      handle_button_nextstrain (event) {
        event.stopImmediatePropagation();
        this.nextstrain_link = this.current_url.protocol + "//" + this.current_url.hostname + "/ra/merge_fasta?my_project=" + this.id_project_detail;
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = this.nextstrain_link;
        dummy.select();
        document.execCommand("copy");
        window.open("https://clades.nextstrain.org/", '_blank');
        this.m_modal_nextstrain( false );
      },


      handle_close_modal_detail () {
        // console.log("Zaviram modal.");
        this.files = [];
        this.xlsx_file = [];
        this.other_files = [];
      },


      handle_close_modal () {
        // console.log("Zaviram modal.");
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },

      handleShowQC (index, row, event) {
        // event.preventDefault();
        event.stopImmediatePropagation();
        // console.log(event);
        // this.m_id_project_detail(row.id_project);
        axios.get(process.env.VUE_APP_BE + '/showqc', { withCredentials: true, params: { id_project: row.id_project, id_examination: 0, filename: "multiqc_report.html" }, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'text', })
            .then(response => {
              // var blob = new Blob(response.data, {type: "text/html; charset=UTF-8"});
              var myWindow = window.open("", "_blank");
              myWindow.document.write(response.data);
              myWindow.document.close();

              // window.open(blob, '_blank');

              // const data = window.URL.createObjectURL(blob);
              // var link = document.createElement('a');
              // link.href = data;
              // link.download = "xxx.html";
              // link.click();
              // setTimeout(function() {
              //   window.URL.revokeObjectURL(data);
              // }, 100);
              // FileSaver.saveAs(blob, response.config.params.filename);
            }, error => {
                console.log(error);
            });


        // axios.get(process.env.VUE_APP_BE + '/showqc', { params: { id_project: row.id_project, id_examination: 0, filename: "multiqc_report.html" },  headers: { 'Authorization': this.token } }, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', } })
        //     .then(response => {
        //         if (response.data["redirect"] > "") {
        //             // window.open(response.data["redirect"], '_blank');
        //             window.open("https://www.seznam.cz/", '_blank').focus();
        //             console.log(response.data["redirect"]);
        //         }
        //     }, error => {
        //         console.log(error);
        //     });

        // fetch(process.env.VUE_APP_BE + '/showqc?id_project=' + row.id_project, {   headers: { 'Authorization': this.token } }, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', } })
        //   .then(async response => {
        //     const data = await response.json();
        //     let myredirect = data.redirect;
        //   })
        //   .finally(() => this.loading = false);
        //   console.log(myredirect);
          // window.open(myredirect, '_blank');
          // window.open("https://www.seznam.cz/", '_blank').focus();
          // console.log(this.qc_redirect);

          // this.a_show_qc( { "id_project": row.id_project } );

          // this.a_notify( { "message": "HELLO!" } );
          // console.log(this.qc_redirect);

        // this.files = [];
        // this.other_files = [];
        // this.csv_file = [];
        // this.m_modal_project_stat(true);
      },


      handleReport (index, row, event) {
        // event.preventDefault();
        event.stopImmediatePropagation();
        // console.log(event);
        // this.m_id_project_detail(row.id_project);
        axios.get(process.env.VUE_APP_BE + '/make_report', { withCredentials: true, params: { id_project: row.id_project }, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'blob', })
            .then(response => {
                     var blob = new Blob([response.data]);
                     FileSaver.saveAs(blob, "report.pdf");

              // var blob = new Blob(response.data, {type: "text/html; charset=UTF-8"});

              // var myWindow = window.open("", "_blank");
              // myWindow.document.write(response.data);
              // myWindow.document.close();

              // window.open(blob, '_blank');

              // const data = window.URL.createObjectURL(blob);
              // var link = document.createElement('a');
              // link.href = data;
              // link.download = "xxx.html";
              // link.click();
              // setTimeout(function() {
              //   window.URL.revokeObjectURL(data);
              // }, 100);
              // FileSaver.saveAs(blob, response.config.params.filename);
            }, error => {
                console.log(error);
            });


        // axios.get(process.env.VUE_APP_BE + '/showqc', { params: { id_project: row.id_project, id_examination: 0, filename: "multiqc_report.html" },  headers: { 'Authorization': this.token } }, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', } })
        //     .then(response => {
        //         if (response.data["redirect"] > "") {
        //             // window.open(response.data["redirect"], '_blank');
        //             window.open("https://www.seznam.cz/", '_blank').focus();
        //             console.log(response.data["redirect"]);
        //         }
        //     }, error => {
        //         console.log(error);
        //     });

      },


      handleNotify (index, row, event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        // this.m_id_project_detail(row.id_project);

        this.a_notify( "TEST notifikace." );
        // this.files = [];
        // this.other_files = [];
        // this.csv_file = [];
        // this.m_modal_project_stat(true);
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


      submit_project_detail(){
        this.a_project_detail(this.project_detail)
        // this.a_notify( { "message": "HELLO!" } );
        // this.m_modal_project_detail(false);

      },

      submit_project_params(){
        // this.a_project_detail(this.project_detail)
        // this.a_notify( { "message": "HELLO!" } );
        // this.m_modal_project_detail(false);

      },



      submit_np(){
        this.a_new_project(this.new_project_name);
        this.m_modal_new_project(false);

      },


      submit_ep(){
        this.a_project_update(this.formdata_ep)
      },


      submit_nss(){
        this.a_project_update_ss(this.formdata_nss)
      },


      add_project(){
        moment.locale("us");
        // this.formdata_np.created_dt = moment(Date().toLocaleString()).format('LLL');
        this.new_project_name = "";

        this.m_id_project(0);
        this.m_project_detail(0);
        this.m_modal_new_project(true);
      },



      load_data_files(tab, event){
        let coll = "";

        if (tab.index === "2") {
          coll = "f_q";

        } else if (tab.index === "3") {
          coll = "f_a";
        } else if (tab.index === "4") {
          coll = "f_m";
        } else if (tab.index === "5") {
          coll = "f_o";
        } else if (tab.index === "6") {
          coll = "f_e";
        } else if (tab.index === "7") {
          coll = "f_u";
        } else if (tab.index === "1") {
          coll = "f_s";
        } else {
            coll = "f_x";
        }
        this.m_collection(coll);

        axios.get(process.env.VUE_APP_BE + '/get_files', { withCredentials: true, params: { "id_project": this.id_project_detail, "collection": coll }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }})
            .then(response => {
              if (tab.index === "2") {
                this.m_f_q(response.data["f_list"]);
              } else if (tab.index === "3") {
                this.m_f_a(response.data["f_list"]);
              } else if (tab.index === "4") {
                this.m_f_m(response.data["f_list"]);
              } else if (tab.index === "5") {
                this.m_f_o(response.data["f_list"]);
              } else if (tab.index === "6") {
                this.m_f_e(response.data["f_list"]);
              } else if (tab.index === "7") {
                this.m_f_u(response.data["f_list"]);
              } else if (tab.index === "1") {
                this.m_f_s(response.data["f_list"]);
              } else {
              }

            }, error => {
                console.log(error);
            });


      },


      fetchEventsList () {
        this.a_projects_refresh();
      },

      cancelAutoUpdate () {
        clearInterval(this.timer)
      },

      // setCurrent(row) {
      //   this.$refs.singleTable.setCurrentRow(row);
      // },
      handleCurrentChange_p(val) {
        // event.stopImmediatePropagation();
        if (val && val.id_project === this.id_project) {
          console.log("CCCCCCC");
          // this.m_id_project(val.id_project);
        }
        else if (val && val.id_project > 0) {
          this.m_id_project(val.id_project);
          this.m_id_examination(0);
          this.m_substs([]);
          this.a_examinations( {"id_project": val.id_project} );
          this.project_name = val.name;
        } else {
          this.m_id_project(0);
          this.m_id_examination(0);
          this.m_substs([]);
          this.project_name = "";
        }
        this.u_f_q
      },

      handleCurrentChange_fd(val) {

      },

      handleCurrentChange_fo(val) {

      },

      handle_mongo_files(index, row, event, type) {
        event.stopImmediatePropagation();
        this.a_mongo_files( {"id_project": this.id_project_detail, "md5": row.md5, "action_type": type} );
      },

      handleCurrentChange_v(val) {
        if (val && val.id_var > 0) {
          // this.a_examinations(val.id_examination);
        } else {
          // this.m_i_examination(0);
        }
      },

      inputFile: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          if (newFile.xhr) {
            //  Get the response status code
            console.log('status', newFile.xhr.status)
          }
        }
      },

      inputFilexlsx: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          if (newFile.xhr) {
            //  Get the response status code
            console.log('status', newFile.xhr.status)
          }
        }
      },

      inputFileOther: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          console.log('response', newFile.response)
          if (newFile.xhr) {
            //  Get the response status code
            this.load_data_files_all();
            console.log('status', newFile.xhr.status)
          }
        }
      },


    },

    beforeMount () {
      this.a_projects();
      this.a_workflows();
      this.m_id_examination(0);
      this.m_id_project(0);
    },

   created () {
        // this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 60000)
    },

    beforeDestroy () {
      clearInterval(this.timer)
    },



  }
</script>
<style scoped lang="scss">
.el-table .td-actions{
  button.btn {
    margin-right: 0px;
  }
}

.el-table {
  font-size: 12px !important;
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}



.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

h4 {
  margin-top: 5px !important;
}

.dolu {
  padding-top: 80px !important;
}

.table > thead > tr > th, .el-table table > thead > tr > th {
  font-size: 12px !important;
}

.mezera {
  margin-right: 10px;
}

.lightgray {
  background-color: rgb(211, 208, 203) !important;
}

.sub-title {
  font-size: 0.7em;
  margin-bottom: 1px;
  margin-top: 10px;
  color: black;
  text-transform: uppercase;
}

.my_asterisk {
  font-size: 14px !important;

}

</style>
